<div class="grid grid-cols-1 xl:grid-cols-2 gap-6">
  <!-- INTERIOR (PIECES) -->
  <div class="bg-orange-1 p-4 rounded-xl border border-orange-3">
    <div class="flex items-center justify-between mb-3">
      <div class="flex items-center gap-2 text-orange-11">
        <mat-icon class="text-sm">meeting_room</mat-icon>
        <h4 class="font-bold uppercase tracking-wider text-xs m-0">Intérieur (Pièces)</h4>
      </div>
      @if (totalInteriorSurface() > 0) {
        <div
          class="px-2 py-0.5 rounded-md bg-orange-a3 text-orange-11 text-[10px] font-bold border border-orange-a4 shadow-xs"
        >
          {{ totalInteriorSurface() }} m² TOTAL
        </div>
      }
    </div>
    <div class="space-y-4">
      <!-- PIECES SUMMARY -->
      <div class="flex items-baseline gap-2 pb-3 border-b border-orange-a4 flex-col">
        <p class="text-xl text-neutral-12 m-0">
          {{ characteristics().interior?.rooms?.length || 0 }}
          <span class="text-base text-neutral-11">pièces</span>
        </p>
        <p class="text-xl text-neutral-12 m-0">
          {{ characteristics().interior?.bedroom?.length || 0 }}
          <span class="text-base text-neutral-11">chambres</span>
        </p>
        <p class="text-xl text-neutral-12 m-0">
          {{
            (characteristics().interior?.bathroom?.length || 0) +
              (characteristics().interior?.showerRoom?.length || 0)
          }}
          <span class="text-base text-neutral-11">salles de bain / d'eau</span>
        </p>
        <p class="text-xl text-neutral-12 m-0">
          {{ characteristics().interior?.wc || 0 }}
          <span class="text-base text-neutral-11">WC</span>
        </p>
      </div>

      <!-- DETAILED LIST -->
      <div class="flex flex-wrap gap-2">
        <!-- Main Rooms -->
        @for (room of characteristics().interior?.rooms; track $index) {
          <span
            class="inline-flex flex-col px-2 py-1.5 rounded-lg bg-orange-a2 border border-orange-3 text-xs text-neutral-11 shadow-xs"
          >
            <div class="flex items-center justify-between gap-3">
              <span class="font-bold text-neutral-12">{{ room.type | etxeEnumDisplay: 'room' }}</span>
              @if (room.surface) {
                <span class="text-orange font-black">{{ room.surface }}m²</span>
              }
            </div>
            @if (room.precision) {
              <div
                class="mt-1 pt-1 border-t border-orange-a3 italic text-[10px] leading-tight text-neutral-10"
              >
                {{ room.precision }}
              </div>
            }
          </span>
        }
        <!-- Bedrooms -->
        @for (bed of characteristics().interior?.bedroom; track $index) {
          <span
            class="inline-flex flex-col px-2 py-1.5 rounded-lg bg-orange-a2 border border-orange-3 text-xs text-neutral-11 shadow-xs"
          >
            <div class="flex items-center justify-between gap-3">
              <span class="font-bold text-neutral-12">Chambre</span>
              @if (bed.surface) {
                <span class="text-orange font-black">{{ bed.surface }}m²</span>
              }
            </div>
            @if (bed.precision) {
              <div
                class="mt-1 pt-1 border-t border-orange-a3 italic text-[10px] leading-tight text-neutral-10"
              >
                {{ bed.precision }}
              </div>
            }
          </span>
        }
        <!-- Bathrooms -->
        @for (bath of characteristics().interior?.bathroom; track $index) {
          <span
            class="inline-flex flex-col px-2 py-1.5 rounded-lg bg-orange-a2 border border-orange-3 text-xs text-neutral-11 shadow-xs"
          >
            <div class="flex items-center justify-between gap-3">
              <span class="font-bold text-neutral-12">SDB</span>
              @if (bath.surface) {
                <span class="text-orange font-black">{{ bath.surface }}m²</span>
              }
            </div>
            @if (bath.precision) {
              <div
                class="mt-1 pt-1 border-t border-orange-a3 italic text-[10px] leading-tight text-neutral-10"
              >
                {{ bath.precision }}
              </div>
            }
          </span>
        }
        <!-- Shower rooms -->
        @for (shower of characteristics().interior?.showerRoom; track $index) {
          <span
            class="inline-flex flex-col px-2 py-1.5 rounded-lg bg-orange-a2 border border-orange-3 text-xs text-neutral-11 shadow-xs"
          >
            <div class="flex items-center justify-between gap-3">
              <span class="font-bold text-neutral-12">SDE</span>
              @if (shower.surface) {
                <span class="text-orange font-black">{{ shower.surface }}m²</span>
              }
            </div>
            @if (shower.precision) {
              <div
                class="mt-1 pt-1 border-t border-orange-a3 italic text-[10px] leading-tight text-neutral-10"
              >
                {{ shower.precision }}
              </div>
            }
          </span>
        }
      </div>
    </div>
  </div>

  <!-- EXTERIOR SECTION -->
  <div class="bg-jade-2 p-4 rounded-xl border border-jade-3">
    <div class="flex items-center justify-between mb-3">
      <div class="flex items-center gap-2 text-jade-11">
        <mat-icon class="text-sm">deck</mat-icon>
        <h4 class="font-bold uppercase tracking-wider text-xs m-0">Extérieur & Annexes</h4>
      </div>
      @if (totalExteriorSurface() > 0) {
        <div
          class="px-2 py-0.5 rounded-md bg-jade-a3 text-jade-11 text-[10px] font-bold border border-jade-a4 shadow-xs"
        >
          {{ totalExteriorSurface() }} m² TOTAL
        </div>
      }
    </div>
    @if (hasExterior()) {
      <div class="flex flex-wrap gap-2">
        @for (item of characteristics().exterior?.garden; track $index) {
          <span
            class="inline-flex flex-col px-2 py-1.5 rounded-lg bg-jade-a2 border border-jade-3 text-xs text-neutral-11 shadow-xs"
          >
            <div class="flex items-center justify-between gap-3">
              <span class="font-bold text-neutral-12">Jardin</span>
              @if (item.surface) {
                <span class="text-jade font-black">{{ item.surface }}m²</span>
              }
            </div>
            @if (item.precision) {
              <div class="mt-1 pt-1 border-t border-jade-a3 italic text-[10px] leading-tight text-neutral-10">
                {{ item.precision }}
              </div>
            }
          </span>
        }
        @for (item of characteristics().exterior?.terrace; track $index) {
          <span
            class="inline-flex flex-col px-2 py-1.5 rounded-lg bg-jade-a2 border border-jade-3 text-xs text-neutral-11 shadow-xs"
          >
            <div class="flex items-center justify-between gap-3">
              <span class="font-bold text-neutral-12">Terrasse</span>
              @if (item.surface) {
                <span class="text-jade font-black">{{ item.surface }}m²</span>
              }
            </div>
            @if (item.precision) {
              <div class="mt-1 pt-1 border-t border-jade-a3 italic text-[10px] leading-tight text-neutral-10">
                {{ item.precision }}
              </div>
            }
          </span>
        }
        @for (item of characteristics().exterior?.balcony; track $index) {
          <span
            class="inline-flex flex-col px-2 py-1.5 rounded-lg bg-jade-a2 border border-jade-3 text-xs text-neutral-11 shadow-xs"
          >
            <div class="flex items-center justify-between gap-3">
              <span class="font-bold text-neutral-12">Balcon</span>
              @if (item.surface) {
                <span class="text-jade font-black">{{ item.surface }}m²</span>
              }
            </div>
            @if (item.precision) {
              <div class="mt-1 pt-1 border-t border-jade-a3 italic text-[10px] leading-tight text-neutral-10">
                {{ item.precision }}
              </div>
            }
          </span>
        }
        @for (item of characteristics().exterior?.loggia; track $index) {
          <span
            class="inline-flex flex-col px-2 py-1.5 rounded-lg bg-jade-a2 border border-jade-3 text-xs text-neutral-11 shadow-xs"
          >
            <div class="flex items-center justify-between gap-3">
              <span class="font-bold text-neutral-12">Loggia</span>
              @if (item.surface) {
                <span class="text-jade font-black">{{ item.surface }}m²</span>
              }
            </div>
            @if (item.precision) {
              <div class="mt-1 pt-1 border-t border-jade-a3 italic text-[10px] leading-tight text-neutral-10">
                {{ item.precision }}
              </div>
            }
          </span>
        }
        @for (item of characteristics().exterior?.swimmingPool; track $index) {
          <span
            class="inline-flex flex-col px-2 py-1.5 rounded-lg bg-jade-a2 border border-jade-3 text-xs text-neutral-11 shadow-xs"
          >
            <div class="flex items-center justify-between gap-3">
              <span class="font-bold text-neutral-12">Piscine</span>
              @if (item.surface) {
                <span class="text-jade font-black">{{ item.surface }}m²</span>
              }
            </div>
            @if (item.precision) {
              <div class="mt-1 pt-1 border-t border-jade-a3 italic text-[10px] leading-tight text-neutral-10">
                {{ item.precision }}
              </div>
            }
          </span>
        }
        @for (item of characteristics().exterior?.cellar; track $index) {
          <span
            class="inline-flex flex-col px-2 py-1.5 rounded-lg bg-jade-a2 border border-jade-3 text-xs text-neutral-11 shadow-xs"
          >
            <div class="flex items-center justify-between gap-3">
              <span class="font-bold text-neutral-12">Cave</span>
              @if (item.surface) {
                <span class="text-jade font-black">{{ item.surface }}m²</span>
              }
            </div>
            @if (item.precision) {
              <div class="mt-1 pt-1 border-t border-jade-a3 italic text-[10px] leading-tight text-neutral-10">
                {{ item.precision }}
              </div>
            }
          </span>
        }
      </div>
    } @else {
      <p class="text-sm text-neutral-10 italic m-0">Aucun espace extérieur renseigné</p>
    }
  </div>

  <!-- PARKING SECTION -->
  <div class="bg-blue-2 p-4 rounded-xl border border-blue-3">
    <div class="flex items-center justify-between mb-3">
      <div class="flex items-center gap-2 text-blue-11">
        <mat-icon class="text-sm">directions_car</mat-icon>
        <h4 class="font-bold uppercase tracking-wider text-xs m-0">Parking</h4>
      </div>
      @if (totalParkingSurface() > 0) {
        <div
          class="px-2 py-0.5 rounded-md bg-blue-a3 text-blue-11 text-[10px] font-bold border border-blue-a4 shadow-xs"
        >
          {{ totalParkingSurface() }} m² TOTAL
        </div>
      }
    </div>
    @if (characteristics().parkings?.length) {
      <div class="space-y-2">
        @for (parking of characteristics().parkings; track $index) {
          <div
            class="flex justify-between items-center text-sm p-2 rounded-lg bg-blue-a2 border border-blue-3"
          >
            <span class="text-neutral-12 font-medium">{{ parking.type | etxeEnumDisplay: 'parking' }}</span>
            <div class="flex items-center gap-2">
              @if (parking.totalSurface) {
                <span class="text-xs text-blue font-bold">{{ parking.totalSurface }}m²</span>
              }
              <span class="font-bold text-blue-11">x{{ parking.count }}</span>
            </div>
          </div>
        }
      </div>
    } @else {
      <p class="text-sm text-neutral-10 italic m-0">Aucun parking renseigné</p>
    }
  </div>

  <!-- COMMON AREAS SECTION -->
  @if (characteristics().commonAreas?.length) {
    <div class="bg-indigo-2 p-4 rounded-xl border border-indigo-3">
      <div class="flex items-center justify-between mb-3">
        <div class="flex items-center gap-2 text-indigo-11">
          <mat-icon class="text-sm">groups</mat-icon>
          <h4 class="font-bold uppercase tracking-wider text-xs m-0">Espaces Communs</h4>
        </div>
        @if (totalCommonAreasSurface() > 0) {
          <div
            class="px-2 py-0.5 rounded-md bg-indigo-a3 text-indigo-11 text-[10px] font-bold border border-indigo-a4 shadow-xs"
          >
            {{ totalCommonAreasSurface() }} m² TOTAL
          </div>
        }
      </div>
      <div class="flex flex-wrap gap-2">
        @for (area of characteristics().commonAreas; track $index) {
          <span
            class="inline-flex flex-col px-2 py-1.5 rounded-lg bg-indigo-a2 border border-indigo-3 text-xs text-neutral-11 shadow-xs"
          >
            <div class="flex items-center justify-between gap-3">
              <span class="font-bold text-neutral-12">{{ area.type | etxeEnumDisplay: 'commonArea' }}</span>
              @if (area.surface) {
                <span class="text-indigo font-black">{{ area.surface }}m²</span>
              }
            </div>
            @if (area.precision) {
              <div
                class="mt-1 pt-1 border-t border-indigo-a3 italic text-[10px] leading-tight text-neutral-10"
              >
                {{ area.precision }}
              </div>
            }
          </span>
        }
      </div>
    </div>
  }

  <!-- EQUIPMENTS & COMFORT SECTION -->
  <div class="bg-neutral-1 p-4 rounded-xl border border-neutral-3">
    <div class="flex items-center gap-2 mb-3 text-neutral-11">
      <mat-icon class="text-sm">auto_awesome</mat-icon>
      <h4 class="font-bold uppercase tracking-wider text-xs m-0">Équipements & Confort</h4>
    </div>
    @if (characteristics().equipments?.items?.length) {
      <div class="flex flex-wrap gap-2">
        @for (item of characteristics().equipments?.items; track item) {
          @let info = getEquipmentInfo(item);
          <span
            class="inline-flex items-center px-2 py-1 rounded bg-neutral-2 border border-neutral-4 text-[11px] text-neutral-11 shadow-sm font-medium"
          >
            <mat-icon class="text-primary text-[14px] w-[14px] h-[14px] mr-1.5">{{ info.icon }}</mat-icon>
            {{ info.label }}
          </span>
        }
      </div>
    } @else {
      <p class="text-sm text-neutral-10 italic m-0">Aucun équipement renseigné</p>
    }
  </div>
</div>
